// extracted by mini-css-extract-plugin
module.exports = {"brand-color":"#0562a6","configBox":"ConfigBox_configBox__1XF4q","title":"ConfigBox_title__1fuXg","content":"ConfigBox_content__16Ce0"};